<app-i18n-dictionary>
    <span [attr.transid]="titleTextId" i18n="@@login-page_title">Login</span>
</app-i18n-dictionary>

<div class="container">
    <div class="login-form" fxLayout="column" fxLayoutAlign="center center">
        <div class="content">
            <h2 i18n="@@request-password-reset-page_headline">Choose your new password</h2>
            <app-password-reset-form (reset)="onReset($event)"
                                     [pending]="isPending$ | async"
                                     [resetError]="resetError$ | async"
                                     [resetSuccessful]="resetSuccessful$ | async"
            ></app-password-reset-form>
        </div>
    </div>
    <div class="teaser-image" [style.background-image]="'url(./assets/images/login/teaser.jpg)'"></div>
</div>
